// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"OpenResetFilter_menuItem__1pv_5"};